// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1000":"d8239e65","1337":"221a1e27","5533":"0f06124a"}[chunkId] + ".css";
};